import { FunctionComponent, memo } from "react";
import urlJoin from "url-join";
import copyToClipboard from "copy-to-clipboard";
import toast from "react-hot-toast";
import Page from "constants/page";
import { faLink } from "@fortawesome/pro-solid-svg-icons";
import { getTimeToRead } from "@edgetier/utilities";
import { EllipsisMenuItem } from "@edgetier/client-components";
import { trackUser } from "utilities/track-user";
import { IProps } from "./copy-url-link.types";
import "./copy-url-link.scss";

/**
 * Button, will copy the the interaction to clipboard
 * @param props.interactionId The ID of the interaction.
 */
const CopyUrlLink: FunctionComponent<IProps> = ({ interactionId }) => {
    const copy = () => {
        const copyText = window.location.origin + urlJoin(Page.Interaction, interactionId);
        copyToClipboard(copyText);
        const successMessage = `Interaction link copied to clipboard`;
        toast.success(successMessage, { duration: getTimeToRead(successMessage, 1000) });
        trackUser("Copy external interaction link to clipboard", { interactionId }, true);
    };
    return (
        <EllipsisMenuItem icon={faLink} onClick={copy}>
            Copy URL link
        </EllipsisMenuItem>
    );
};

export default memo(CopyUrlLink);
